import React, { useEffect, useRef, useState } from "react";
import {
  CContainer,
  CHeader,
  CHeaderNav,
  CButton,
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {
  cilSync,
  cilFile,
  cilLocationPin,
  cilAccountLogout,
  cilSettings,
  cilBook,
  cilPlus,
} from "@coreui/icons";
import { toast } from "react-toastify";
import "../HeaderTop/HeaderTop.scss";
import SettingsNeuralModule from "../NeuralNetworkModule/SettingsNeuralModule";
import Customers from "../Customers/Customers";
import AddObjects from "../Objects/AddObjects";

const HeaderTop = ({
  onAdd,
  onMove,
  onView,
  onDetect,
  customerId,
  onObjectAdded,
  userPermissions,
}) => {
  const headerRef = useRef();
  const [isSettingsModalOpen, setIsSettingsModalOpen] = React.useState(false);
  const [isAddObjectsModalOpen, setIsAddObjectsModalOpen] =
    React.useState(false);
  const [openModal, setOpenModal] = useState(false);

  const OpenModalHandler = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    const onScroll = () => {
      if (headerRef.current) {
        headerRef.current.classList.toggle(
          "shadow-sm",
          document.documentElement.scrollTop > 0
        );
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => document.removeEventListener("scroll", onScroll);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const handleExport = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("openCamera");
    } else {
      toast("Функция доступна только в мобильном приложении");
    }
  };

  const toast_message = () => {
    toast("В разработке");
  };

  const handleLogout = () => {
    if (window.Android && typeof window.Android.clearAuthToken === "function") {
      window.Android.clearAuthToken();
    } else {
      console.log("Интерфейс для очистки токена не найден.");
    }
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const handleOpenSettings = () => {
    setIsSettingsModalOpen(true);
  };

  const handleAddObjects = () => {
    if (customerId) {
      setIsAddObjectsModalOpen(true);
    } else {
      toast.error("Для добавления объекта необходимо в списке слева выбрать вкладку Текущие объекты, далее выбрать заказчика из списка.");
    }
  };

  const handleObjectSelect = (object) => {
    toast.success(`Выбран объект: ${object.ObjectName}`);
    if (onAdd) {
      onAdd(object);
    }
  };

  const isAdmin =
    userPermissions?.permissions?.is_admin ||
    userPermissions?.is_admin ||
    userPermissions?.role === "admin";

  return (
    <>
      <CHeader position="sticky" className="p-0" ref={headerRef}>
        <CContainer className="px-4 pt-2 pb-2 d-flex align-items-center" fluid>
          <CHeaderNav className="d-flex gap-2 w-100">
            <div className="left-top-bar">
              <CButton
                className="btn-gray text-secondary"
                variant="ghost"
                onClick={handleReload}
              >
                <CIcon icon={cilSync} /> Обновить
              </CButton>
            </div>
            <div className="right-top-bar">
              {/* Кнопка всегда видна, но логика внутри handleAddObjects проверяет наличие customerId */}
              <CButton
                className="btn-gray text-secondary"
                variant="ghost"
                onClick={handleAddObjects}
                style={{ fontWeight: "600" }}
              >
                <CIcon icon={cilPlus} /> Добавить объект
              </CButton>

              {isAdmin && (
                <CDropdown>
                  <CDropdownToggle
                    className="btn-gray text-secondary"
                    variant="ghost"
                  >
                    <CIcon icon={cilBook} /> Справочник
                  </CDropdownToggle>

                  <CDropdownMenu>
                    <CDropdownItem href="#">Дефекты конструкций</CDropdownItem>
                    <CDropdownItem href="#">
                      Дефекты, используемые в объектах
                    </CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">
                      Конструктивные решения
                    </CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#" onClick={OpenModalHandler}>
                      Заказчики
                    </CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Организации</CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Опоры</CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Состояния</CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Конструкции</CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">
                      Антенное оборудование
                    </CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">
                      Сведения об организации
                    </CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Склад</CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Рабочий календарь</CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Мониторинг</CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem href="#">Управленческий учет</CDropdownItem>
                  </CDropdownMenu>
                </CDropdown>
              )}

              {/* Кнопки "Настройки нейросети", "Экспорт" и "Карта" только для админа */}
              {isAdmin && (
                <>
                  <CButton
                    className="btn-gray text-secondary"
                    variant="ghost"
                    onClick={handleOpenSettings}
                  >
                    <CIcon icon={cilSettings} /> Настройки
                    нейросети
                  </CButton>

                  <CButton
                    className="btn-green"
                    variant="ghost"
                    onClick={handleExport}
                  >
                    <CIcon icon={cilFile} /> Экспорт
                  </CButton>

                  <CButton
                    className="btn-gray text-secondary"
                    variant="ghost"
                    onClick={toast_message}
                  >
                    <CIcon icon={cilLocationPin} /> Карта
                  </CButton>
                </>
              )}

              <CButton
                className="btn-gray text-secondary"
                variant="ghost"
                onClick={handleLogout}
              >
                <CIcon icon={cilAccountLogout} /> Выйти
              </CButton>
            </div>
          </CHeaderNav>
        </CContainer>
      </CHeader>

      <Customers visible={openModal} onClose={() => setOpenModal(false)} />

      <SettingsNeuralModule
        visible={isSettingsModalOpen}
        onClose={() => setIsSettingsModalOpen(false)}
      />

      <AddObjects
        visible={isAddObjectsModalOpen}
        onClose={() => setIsAddObjectsModalOpen(false)}
        onObjectSelect={handleObjectSelect}
        customerId={customerId}
        onObjectAdded={onObjectAdded}
      />
    </>
  );
};

export default HeaderTop;